<template>
<div class="work" id="design-2">
	<h2><span>02</span>BankTools</h2>
	<div class="subtitle">
		<h3><span>Year</span>2017</h3>
		<h3><span>Products</span>Logo, business card, typography</h3>
	</div>
	<figure>
		<span><img src="../../assets/logo_banktools.jpg" alt="Logo Bank Tools"></span><img>
	</figure>
	<figure>
		<img src="../../assets/cartao_banktools.jpg" alt="cartão Bank Tools">
		<figcaption>
			<p>The Bank Tools works with automation and process for financial market, one of the centered concept was show how new is the kind of operation they are doing</p>
			<p>All colors is the main concept, even the typograph has the objective of combining with colors with intuition of a new and technological service with high trust performance</p>
			<p>To give strength to logo the symbol of machine target and code brackets to finish the idea</p>
		</figcaption>
	</figure>
	<blockquote>
		"I've worked on the entire creative process of Bank Tools, even the web development, but was the brand who push me more, there's no other company as reference, working with exactly the same services" 
	</blockquote>
</div>
</template>